export enum Role {
  superUser = 1,
  strataManager = 2,
  clientManager = 3,
  clientViewer = 5,
}

export enum RoleNames {
  superUser = 'Super User',
  strataManager = 'Strata Manager',
  clientManager = 'Client Manager',
  clientViewer = 'Client Viewer',
}

const permissions = [
  {
    id: 'get::/debug',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/dashboard',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/dashboard/primary',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/dashboard',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/dashboard/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/dashboard/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/dashboard/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/dashboard/:id(\\d+)/favourite',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/dashboard/:id(\\d+)/favourite',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/dashboard/favourite/order',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/dashboard/:id(\\d+)/primary',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'delete::/dashboard/:id(\\d+)/primary',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'get::/dashboard/default',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'patch::/dashboard/:id(\\d+)/share',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/dashboard/:id(\\d+)/share-to-user-type',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/dashboard/:id(\\d+)/duplicate',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/dashboard-panel-templates',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/dashboard-panel-templates',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/dashboard-panel-templates/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/dashboard-panel-templates/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/dashboard-panel-templates/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/dashboard/configuration',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/dashboard/configuration',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/query',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/report/machine-interaction-gantt',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-interaction-gantt-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-overview-bar',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-overview-line',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-overview-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-details-bar',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-details-line',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-details-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-history-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-status',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-interaction-chart',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-interaction-grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/interactions-per-machine',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/interactions-per-machine-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/top-bottom-interactions',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/top-bottom-interactions-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/interactions-last-10-days',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/interactions-last-10-days-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/human-overview',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/human-overview-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/human-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/human-history-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/checkout-overview-grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/checkout-overview-chart',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/checkout-details-grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/checkout-details-chart',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/heat-map',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/machine-input',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/machine-input',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/machine-input/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/machine-input/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/machine-input/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/machine-type',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/machine-type',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/machine-type/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/machine-type/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/machine-type/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/map',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/map/source',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/map/source/preview',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/map/source/:sourceFilename/preview',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/map/source/:sourceFilename',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/map/tiling-job',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/map/tiling-job',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/map/tiling-job/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/map/tiling-job/:id/retry',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/map/tiling-job/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/map',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/map/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/map/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/company/current',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/company',
    roles: [1],
    configurable: false,
  },
  {
    id: 'get::/company/:id(\\d+)',
    roles: [1],
    configurable: false,
  },
  {
    id: 'post::/company',
    roles: [1],
    configurable: false,
  },
  {
    id: 'patch::/company/current',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'patch::/company/:id(\\d+)',
    roles: [1],
    configurable: false,
  },
  {
    id: 'delete::/company/:id(\\d+)',
    roles: [1],
    configurable: false,
  },
  {
    id: 'delete::/company/:id(\\d+)/data',
    roles: [1],
    configurable: false,
  },
  {
    id: 'delete::/company/:id(\\d+)/asset',
    roles: [1],
    configurable: false,
  },
  {
    id: 'get::/subscription',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/subscription',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/subscription/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/subscription/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/subscription/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/subscription-report',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/subscription-report',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/subscription-report/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/subscription-report/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/subscription-report/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/asset-machine',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/asset-machine',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/asset-machine/remove-events',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/asset-machine/remove-machines',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-machine/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/asset-machine/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/asset-machine/:id/update_network_id',
    roles: [1, 2, 3],
    configurable: true,
    label: 'Update Asset Network ID',
    order: 80,
  },
  {
    id: 'delete::/asset-machine/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-human',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/asset-human',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-human/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/asset-human/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/asset-human/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-human-type',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/asset-human-type',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-human-type/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/asset-human-type/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/asset-human-type/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-human-group',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/asset-human-group-grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/asset-human-group-types',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/asset-human-group',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset-human-group/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/asset-human-group/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/asset-human-group/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/report/machine-summary',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/report/machine-summary-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/configuration',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/configuration',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/configuration',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/user-configuration',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/user-configuration',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/user-configuration',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/user/:user_id/permissions',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/user/:user_id/permissions',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/logo',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/logo',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/asset',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/layer',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/layer',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/layer/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/layer/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/layer/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/zone',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/zone-by-group-id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/zone',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/zone/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/zone/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/zone/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/admin-commtrac-node',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node-grid',
    roles: [1, 2, 3, 5],
    configurable: false,
    label: 'Employees/Assets Tab Access',
  },
  {
    id: 'post::/commtrac-node',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/commtrac-node/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/commtrac-node/remove-events',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/commtrac-node/remove-employees',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node/:id(\\d+)/history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node/:id(\\d+)/history/report',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/force_check_in',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/force_check_out',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node/export-fields',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/activate',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/deactivate',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/miner/broadcast_report_frequency',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/auth/logout',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/user/me',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/user/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/user',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/user',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/user/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/user/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/commtrac-node-miner/force-check-in',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/commtrac-node-miner/force-check-out',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/communication-node/remove-events',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/communication-node/remove-nodes',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/m-processor/get-logs',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/m-processor/start',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/m-processor/stop',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/m-cron/status',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'get::/commtrac-broadcast-message',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/commtrac-broadcast-message',
    roles: [1, 2, 3, 5],
    configurable: true,
    label: 'Send Broadcast Message',
    order: 50,
  },
  {
    id: 'patch::/commtrac-broadcast-message/:id/clear',
    roles: [1, 2, 3, 5],
    configurable: true,
    label: 'Clear Broadcast Message',
    order: 60,
  },
  {
    id: 'get::/event',
    roles: [1, 2, 3, 5],
    configurable: false,
    label: 'Events Grid',
  },
  {
    id: 'get::/event/summary',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/event/acknowledge',
    roles: [1, 2, 3, 5],
    configurable: true,
    label: 'Acknowledge Events',
    order: 10,
  },
  {
    id: 'patch::/event/acknowledge-all',
    roles: [1, 2, 3, 5],
    configurable: true,
    label: 'Acknowledge All Events',
    order: 20,
  },
  {
    id: 'post::/purge',
    roles: [2],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/miner/force_check_in',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/miner/force_check_out',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/miner/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/miner/move_to_asset',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/miner/report_frequency',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/asset-human/:id/update_network_id',
    roles: [1, 2, 3],
    configurable: true,
    label: 'Update Employee Node Network ID',
    order: 70,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/asset/force_check_in',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/asset/force_check_out',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/asset/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/shift',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/shift',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/shift/:id',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/shift/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/shift/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node/grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/communication-node/network-general-grid',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/network-general-grid-export',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/network-routing-grid',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/network-routing-grid-export',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/network-timing-grid',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/network-timing-grid-export',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/event-grid',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/communication-node/events',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/node',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/node-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/node/activate',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/deactivate',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/node/communication-node',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/node/communication-node',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/node/:id/communication-node',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/communication-node',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/communication-node/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/communication-node/reset',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/communication-node/update_networkd_id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/communication-node/report_frequency',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/communication-node/make_secondary',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/node/communication-node/broadcast_report_frequency',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/node/wifi-point',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/node/wifi-point',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/node/:id/wifi-point',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/node/:id/wifi-point/events',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/node/:id/wifi-point/long-events',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/wifi-point',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/wifi-point/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/node/:id/wifi-point/update_networkd_id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/backhauler',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/backhauler/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/backhauler',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/backhauler/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/backhauler/:id(\\d+)/summary',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/backhauler/:id(\\d+)/start',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/backhauler/:id(\\d+)/stop',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/backhauler/start-all',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/backhauler/stop-all',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/system/status',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/commtrac-node/:id(\\d+)/message',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/commtrac-node/:id(\\d+)/message',
    roles: [1, 2, 3, 5],
    configurable: true,
    label: 'Send Text Message',
    order: 30,
  },
  {
    id: 'delete::/commtrac-node/:id(\\d+)/message',
    roles: [1, 2],
    configurable: false,
    label: 'Delete Text Message',
    order: 40,
  },
  {
    id: 'get::/group-message',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/group-message',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'delete::/group-message',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'get::/proximity/import',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/proximity/import',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/proximity/import/:id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/alarm-module',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/alarm-module',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/alarm-module/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/alarm-module/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/alarm-module/:id(\\d+)/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/alarm-module/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/alarm-module-group',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/alarm-module-group',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/alarm-module-group/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/alarm-module-group/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/alarm-module-group/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/alarm-module/alarm/enable',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/alarm-module/alarm/disable',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/alarm-module/:id(\\d+)/history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/alarm-module/:id(\\d+)/log',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/user/:id(\\d+)/event-subscription',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/user/:id(\\d+)/event-subscription',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/backend/mqtt/summary',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/backend/mqtt/start',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/backend/mqtt/stop',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/backend/frontend/summary',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/backend/frontend/restart',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/backend/summary',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/backend/restart',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/site',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/site',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/site/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/site/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/site/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/site-permissions/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/site-permissions/user/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/site-permissions',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/site-permissions/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/site-permissions',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/safeye-nano-node',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'post::/safeye-nano-node',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/safeye-nano-node/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/safeye-nano-node/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/safeye-nano-node/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/safeye-nano-node/:id(\\d+)/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/safeye-nano-node/:id(\\d+)/assign',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/safeye-nano-node/:id(\\d+)/no-heartbeat-event',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/safeye-nano-node/:safeye_node_id/remote-access',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/:id(\\d+)/detection-event-log',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/:asset_machine_id(\\d+)/machine-location-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/machine-summary-grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/detection-chart',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/detection-total',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/detection-graph',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/detection-heat-map',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/detection-event/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/machine-utilization',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/machine-interaction',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/machine-speed-chart',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/hazard-ai/daily-breakdown',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/hazard-ai/:id(\\d+)/false-detection',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'delete::/hazard-ai/:id(\\d+)/detection',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'post::/ams',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/ams/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/ava',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/network_id',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/disable_event',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/stand_down',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/ventilation_failure',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/ams/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/ams',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/ava_test',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/ams/emodule',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/ams/emodule/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/ams/emodule/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/ams/emodule/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/ams/emodule',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/emodule/:id(\\d+)/sensor-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/emodule/:id(\\d+)/sensor-history-export',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/emodule/:emodule_id(\\d+)/calibration-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/emodule/:id(\\d+)/installation-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/miner/reassign',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/commtrac-node/:id(\\d+)/asset/reassign',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/ams/:id(\\d+)/:emodule_id(\\d+)/short-term-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/:id(\\d+)/long-term-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/:id(\\d+)/location-history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/ams/:id(\\d+)/statistic',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/ams/blast_mode',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/emodule/:id(\\d+)/calibration_mode',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/emodule/:id(\\d+)/event-delay/:channel(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/ams/:id(\\d+)/input-status-event',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/v1/commtrac-node-miner/grid',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/v1/commtrac-node-asset/grid',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/belt/:commtrac_external_id(\\d+)/history',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/belt/:commtrac_external_id(\\d+)/location',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  // belts begin
  {
    id: 'post::/belt',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/belt/:id(\\d+)',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/acknowledge',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/belt',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/belt/raw',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/misc-output',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/start',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/stop',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/reset',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/reporting-frequency',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/location-frequency',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/belt/:id(\\d+)/network-id',
    roles: [1, 2, 3],
    configurable: false,
  },
  // belts end
  // gateway begin
  {
    id: 'post::/gateway',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'delete::/gateway/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/gateway',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/gateway/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/gateway/:id(\\d+)/summary',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/gateway/:id(\\d+)/start',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/gateway/:id(\\d+)/stop',
    roles: [1, 2, 3],
    configurable: false,
  },
  // gateway end
  // shaft clearance start
  {
    id: 'get::/shaft-clearance/assets',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/miners',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/employee/grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/employee/chart',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/employee/graph',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/asset/grid',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/asset/chart',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  {
    id: 'get::/shaft-clearance/asset/graph',
    roles: [1, 2, 3, 5],
    configurable: false,
  },
  // shaft clearance end
  // User Groups
  {
    id: 'get::/user-group',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'get::/user-group/:id(\\d+)',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'post::/user-group',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'patch::/user-group/:id(\\d+)',
    roles: [1, 2],
    configurable: false,
  },
  {
    id: 'delete::/user-group/:id(\\d+)',
    roles: [1, 2],
    configurable: false,
  },
  // User group membership
  {
    id: 'get::/user/:id(\\d+)/groups',
    roles: [1, 2, 3],
    configurable: false,
  },
  {
    id: 'patch::/user/:id(\\d+)/groups',
    roles: [1, 2, 3],
    configurable: false,
  },
  // User Groups end
] as const;

export type Permission = (typeof permissions)[number]['id'];

export type Rule = 'canConfigurationProducts';

export const rules: {
  [k in Rule]: number[];
} = {
  canConfigurationProducts: [1, 2],
};
